import * as React from "react";
import cn from "classnames";
export const RestaurantIconList = {
    chilli: "chilli",
    apricot: "apricot",
    banana: "banana",
    barbecueA: "barbecueA",
    barbecueB: "barbecueB",
    beer_mug: "beer_mug",
    bottle: "bottle",
    bowl: "bowl",
    bread: "bread",
    burgerA: "burgerA",
    burgerB: "burgerB",
    cakeA: "cakeA",
    cakeB: "cakeB",
    candyA: "candyA",
    candyB: "candyB",
    carrot: "carrot",
    chefs_hat: "chefs_hat",
    citrus: "citrus",
    coffee_2: "coffee_2",
    coffee_1: "coffee_1",
    coffee: "coffee",
    croissant_1: "croissant_1",
    croissant: "croissant",
    decanter: "decanter",
    egg_3: "egg_3",
    egg_2: "egg_2",
    egg_1: "egg_1",
    egg: "egg",
    fastfood: "fastfood",
    fire: "fire",
    fork: "fork",
    fruits: "fruits",
    garlic: "garlic",
    grill: "grill",
    hazelnut: "hazelnut",
    icecream_1: "icecream_1",
    icecream: "icecream",
    kettle: "kettle",
    kettle_1: "kettle_1",
    kiwi: "kiwi",
    knives: "knives",
    lemon: "lemon",
    lemonade: "lemonade",
    mushroom: "mushroom",
    olive: "olive",
    pan: "pan",
    pear: "pear",
    pizza: "pizza",
    plate: "plate",
    pot: "pot",
    potholder: "potholder",
    salver: "salver",
    sausage: "sausage",
    scales: "scales",
    skimmer: "skimmer",
    spatula: "spatula",
    steak: "steak",
    tableware: "tableware",
    tomato: "tomato",
    turkey: "turkey",
    wheat: "wheat",
    whiskey: "whiskey",
    wineglass: "wineglass",
    apple: "apple",
};
export const RestaurantIcon = (props) => React.createElement("span", { ...props, className: cn(props.className, `ricon-${props.icon}`) });
//# sourceMappingURL=index.js.map